


import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// 🔹 Pages
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Upload from "./pages/Upload";
import EditAgent from "./pages/EditAgent";
import EditAgentList from "./pages/EditAgentList";
import FormPage from "./pages/FormPage";
import SendFormPage from "./pages/SendFormPage";
import ManageAgentPage from "./pages/ManageAgentPage";
import LogsReportPage from "./pages/LogsReportPage";
import AdminApprovalPage from "./pages/AdminApprovalPage";
import DownloadExcelPage from "./pages/DownloadExcelPage";
import SubmittedPage from "./pages/SubmittedPage";
import LandingPage from "./pages/LandingPage";
import SummaryPage from "./pages/SummaryPage";
import RejectedAgentsPage from "./pages/rejectedpage";
import DownloadExcelPageForAccounts from "./pages/downloadexcelforaccounts";




// 🔐 Protected Route (UPDATED WITH ROLE SUPPORT)
const ProtectedRoute = ({ children, roleRequired }) => {
  const isAuth = localStorage.getItem("admin_id");
  const role = localStorage.getItem("role");

  // ❌ Not logged in
  if (!isAuth) {
    return <Navigate to="/" replace />;
  }

  // 🔒 Role restriction
  if (roleRequired && role !== roleRequired) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};





function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* 🔓 PUBLIC ROUTES */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        

        <Route path="/form/:token" element={<FormPage />} />

        {/* 🔒 PROTECTED ROUTES */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/upload"
          element={
            <ProtectedRoute>
              <Upload />
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-list"
          element={
            <ProtectedRoute>
              <EditAgentList />
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit/:id"
          element={
            <ProtectedRoute>
              <EditAgent />
            </ProtectedRoute>
          }
        />

        <Route
          path="/send-form"
          element={
            <ProtectedRoute>
              <SendFormPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/manage-agents"
          element={
            <ProtectedRoute>
              <ManageAgentPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/logs"
          element={
            <ProtectedRoute>
              <LogsReportPage />
            </ProtectedRoute>
          }
        />

        {/* ✅ NEW ADMIN PAGE (ONLY ADMIN CAN ACCESS) */}
        <Route
          path="/admin-approval"
          element={
            <ProtectedRoute roleRequired="admin">
              <AdminApprovalPage />
            </ProtectedRoute>
          }
        />

        {/* 🔄 FALLBACK */}
        <Route path="*" element={<Navigate to="/" replace />} />

        <Route
          path="/download-excel"
          element={
            <ProtectedRoute >
              <DownloadExcelPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/submitted"
          element={
            <ProtectedRoute>
              <SubmittedPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/rejected-agents"
          element={
            <ProtectedRoute>
              <RejectedAgentsPage />
            </ProtectedRoute>
          }
        />



        <Route
          path="/download-excel-for-accounts"
          element={
            <ProtectedRoute >
              <DownloadExcelPageForAccounts />
            </ProtectedRoute>
          }
        />

        <Route
  path="/summary"
  element={
    <ProtectedRoute>
      <SummaryPage />
    </ProtectedRoute>
  }
/>

      </Routes>


    </BrowserRouter>
  );
}

export default App;